import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'
import moment from 'moment-timezone'
import Api from '@/api/api.js'
import Buefy from 'buefy'
import Storage from 'vue-ls'
import Print from 'vue-print-nb'
import Swal from 'sweetalert2'
import { Printd } from 'printd'

import Config from '../config'

import 'buefy/dist/buefy.css'

import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

import AllIosIcon from 'vue-ionicons/dist/ionicons-ios.js'
import Paginate from 'vuejs-paginate'

require('vue-ionicons/ionicons.css')

Vue.config.productionTip = false
Vue.prototype.$axios = Axios
Vue.prototype.$api = Api
Vue.prototype.$axios.defaults.baseURL = Config.serverUrl

Vue.prototype.$config = Config
Vue.prototype.$swal = Swal

Vue.prototype.$printd = new Printd()

Vue.prototype.$moment = moment
Vue.prototype.$moment.tz.setDefault('Asia/Yangon')

Vue.use(Print)
Vue.use(Buefy)
Vue.use(AllIosIcon)

Vue.component('paginate', Paginate)

const options = {
	namespace: 'vuejs__', // key prefix
	name: 'ls', // name variable Vue.[ls] or this.[$ls],
	storage: 'session' // storage name session, local, memory
}

Vue.use(Storage, options)

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
